import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import SecurityAssessment from './security-assessment-&-risk-analysis/index.jsx'
import AboutUs from './about-us/index.jsx'
import Services from './services/index.jsx'
import Home from './home/index.jsx'
import Datenschutz from './pages/Datenschutz'
import Impressum from './pages/Impressum'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/security-assessment" element={<SecurityAssessment />} />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/impressum" element={<Impressum />} />
        <Route path="*" element={<div>404 Page Not Found</div>} />
      </Routes>
    </BrowserRouter>
  )
}

export default App 